import KendoMultiSelectMixin from './KendoMultiSelectMixin'

export default {
    name: 'kendo-multiselect',
    mixins: [ KendoMultiSelectMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiSelect/index.js